
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'

import useClipboard from 'vue-clipboard3'

import COVERAPP from '@/utils/COVERAPP'

import Pop from '@/components/Pop.vue'
import Toast from '@/components/Toast.vue'
import Upload from '@/components/Upload.vue'

export default defineComponent({
    components: {
        Pop,
        Toast,
        Upload
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const _this = getCurrentInstance() as any
        // 导航选中index
        const curIndex = ref<number>(0)
        const wapUploadPopShow = ref<boolean>(false)
        // 条款类型
        const popType = ref<number>(0)
        // 报名成功弹框是否显示
        const applyPopShow = ref<boolean>(false)
        // toast弹框数据
        const toastData = ref<any>(null)
        // 是否已经报过名
        const isApplyed = ref<boolean>(false)
        // 作品列表
        const worksList = ref<any>([])
        const worksListShow = ref<boolean>(false)
        // 是否可以开始报名
        const canApply = ref<boolean>(false)
        // 作品数量是否超过限制
        const worksOverPopShow = ref<boolean>(false)
        // 队伍属性类型
        const teamAttrs = ref<any>([
            {
                name: '机构',
                selected: true,
                subList: [
                    {
                        name: '企事业单位',
                        selected: true
                    },
                    {
                        name: '高校',
                        selected: false
                    },
                    {
                        name: '科研院所',
                        selected: false
                    },
                    {
                        name: '社会组织',
                        selected: false
                    }
                ]
            },
            {
                name: '个人',
                selected: false
            }
        ])
        // 建设方向类型
        const themeAttrs = ref<any>([
            {
                id: 'theme_01',
                name: '促进乡村数字经济发展',
                selected: false
            },
            {
                id: 'theme_02',
                name: '提升乡村数字化治理水平',
                selected: false
            },
            {
                id: 'theme_03',
                name: '推进乡村智慧化绿色化',
                selected: false
            },
            {
                id: 'theme_04',
                name: '繁荣乡村网络文化',
                selected: false
            },
            {
                id: 'theme_05',
                name: '提升信息惠民服务能级',
                selected: false
            },
            {
                id: 'theme_06',
                name: '深化拓展网络帮扶',
                selected: false
            },
            {
                id: 'theme_07',
                name: '数字乡村建设的其他方向',
                selected: false
            }
        ])
        // 报名信息表单数据
        const applyFormData = reactive<any>({
            name: '',
            tel: '',
            idcardPic: '',
            idcardBackPic: '',
            teamName: '',
            teamPic: '',
            team: '企事业单位',           
            // cardPic: '',
            isAgreed: ''
        })
        // 报名信息表单规则
        const applyFormRule = reactive<any>({
            name: {
                isReuired: true,
                msg: {
                    isReuired: '请输入联系人姓名'
                },
                error: ''
            },
            tel: {
                rule: /^((\d{3,4})|\d{3,4}-|s)?\d{7,14}$/,
                isReuired: true,
                msg: {
                    rule: '请输入正确的电话号码！',
                    isReuired: '请输入联系人电话'
                },
                error: ''
            },
            idcardPic: {
                isReuired: true,
                msg: {
                    isReuired: '请上传身份证正面',
                    format: '图片格式不正确！',
                    size: '图片大小超过2M'
                },
                error: ''
            },
            idcardBackPic: {
                isReuired: true,
                msg: {
                    isReuired: '请上传身份证背面',
                    format: '图片格式不正确！',
                    size: '图片大小超过2M'
                },
                error: ''
            },
            team: {
                isReuired: true,
                msg: {
                    isReuired: '请选择队伍属性'
                },
                error: ''
            },
            teamName: {
                isReuired: true,
                msg: {
                    isReuired: '请输入队伍名'
                },
                error: ''
            },
            teamPic: {
                isReuired: false,
                msg: {
                    isReuired: '请上传队伍logo',
                    format: '图片格式不正确！',
                    size: '图片大小超过2M'
                },
                error: ''
            },
            // cardPic: {
            //     isReuired: true,
            //     msg: {
            //         isReuired: '请上传身份证明',
            //         format: '图片格式不正确！',
            //         size: '图片大小超过2M'
            //     },
            //     error: ''
            // },
            isAgreed: {
                isReuired: true,
                msg: {
                    isReuired: '请仔细阅读并勾选条款'
                },
                error: ''
            }
        })
        // 提交作品表单数据
        const worksFormData = reactive<any>({
            worksName: '',
            themes: '',
            worksPic: '',
            works: '',
            worksFileName: '',
            brief: '',
            isLetterAgreed: '',
            isWorksAgreed: ''
        })
        // 提交作品表单规则
        const worksFormRule = reactive<any>({
            worksName: {
                isReuired: true,
                msg: {
                    isReuired: '请输入作品名称'
                },
                error: ''
            },
            worksPic: {
                isReuired: true,
                msg: {
                    isReuired: '请上传作品主图',
                    format: '图片格式不正确！',
                    size: '图片大小超过2M'
                },
                error: ''
            },
            themes: {
                isReuired: true,
                msg: {
                    isReuired: '请选择建设方向'
                },
                error: ''
            },
            works: {
                isReuired: true,
                msg: {
                    isReuired: '请上传作品',
                    format: '文件格式不正确！',
                    size: '文件大小超过1G',
                    limit: '同一参赛主体在相同建设方向下提交的相似作品数量不得超过3个。您可以调整参赛方向后重试。',
                    maxLen: '同一参赛主体在相同建设方向下提交的相似作品数量不得超过3个。您可以调整参赛方向后重试。'
                },
                maxLen: 3,
                error: ''
            },
            worksFileName: {
                isReuired: false,
                error: ''
            },
            brief: {
                isReuired: true,
                msg: {
                    isReuired: '请输入作品简介'
                },
                error: ''
            },
            isLetterAgreed: {
                isReuired: true,
                msg: {
                    isReuired: '请仔细阅读并勾选知识产权承诺函'
                },
                error: ''
            },
            isWorksAgreed: {
                isReuired: true,
                msg: {
                    isReuired: '请仔细阅读并勾选条款'
                },
                error: ''
            }
        })

        // 是否获取过了报名信息
        const isGetInfoed = ref<boolean>(false)
        let applyedData: any = {}
        // 获取报名信息
        const getInfo = () => {
            _this.proxy.$request('/temporary/xcds', {
                aid: $store.state.aid,
                phone: sessionStorage.getItem('xcds_phone')
            }).then((data) => {
                // 有数据则已经报过名
                if (data && data.name) {
                    isApplyed.value = true
                    applyPopShow.value = true
                    applyedData = JSON.parse(JSON.stringify(data))
                    resetTeamAttrs(data.team)
                    // changeTeam(data.team)
                    // 填空报名信息
                    for(let key in applyFormData) {
                        applyFormData[key] = data[key]
                    }
                    if (data.worksList) {
                        worksList.value = JSON.parse(data.worksList);
                    }
                }
                isGetInfoed.value = true
                _this.proxy.$common.pageLoaded()
            }).catch((res) => {
                // token过期去到报名页面
                if (res && res.errno == 1001) {
                    $router.replace('/login')
                    return
                }
                isGetInfoed.value = true
                _this.proxy.$common.pageLoaded()
            })
        }
        // sessionStorage内没有电话号码，去到报名页面
        if (sessionStorage.getItem('xcds_phone')) {
            getInfo()
        } else {
            $router.replace('/login')
        }

        // 接口返回的数据处理teamAttrs
        const resetTeamAttrs = (name: string) => {
            if (name == '个人') {
                teamAttrs.value[0].selected = false
                teamAttrs.value[1].selected = true
            } else {
                teamAttrs.value[0].subList.forEach((val) => {
                    if (val.name == name) {
                        val.selected = true
                    } else {
                        val.selected = false
                    }
                })
            }
        }
        
        // 选择队伍属性 参数：issub是否是属性下面的子列表
        const selectTeam = (index: number, issub) => {
            if (!issub) {
                teamAttrs.value.forEach((val, idx) => {
                    if (idx === index) {
                        val.selected = true
                    } else {
                        val.selected = false
                    }
                    return val
                })
                if (index === 1) {
                    applyFormData.team = '个人'
                } else {
                    teamAttrs.value[0].subList.forEach((val, idx) => {
                        if (val.selected == true) {
                            applyFormData.team = val.name
                        }
                    })
                }
            } else {
                teamAttrs.value[0].subList.forEach((val, idx) => {
                    if (idx === index) {
                        val.selected = true
                    } else {
                        val.selected = false
                    }
                    return val
                })
                applyFormData.team = teamAttrs.value[0].subList[index].name
            } 
            // changeTeam(applyFormData.team)
        }
        // 选择了队伍属性，对应的身份证明必填项发生变化
        const changeTeam = (val: string) => {
            if (val !== '个人') {
                applyFormRule.cardPic.isReuired  = true
                applyFormRule.idcardPic.isReuired  = false
                applyFormRule.idcardBackPic.isReuired = false
            } else {
                applyFormRule.cardPic.isReuired  = false
                applyFormRule.idcardPic.isReuired  = true
                applyFormRule.idcardBackPic.isReuired = true
            }
        }

        // 选择建设方向
        const selectTheme = (index: number) => {
            themeAttrs.value.forEach((val, idx) => {
                if (idx === index && !val.selected) {
                    val.selected = true
                }
                return val
            })
            getThemes()
        }
        // 移除选择的建设方向
        const removeSelected = (index: number) => {
            themeAttrs.value[index].selected = false
            getThemes()
        }
        // 把建设方向合并为字符串
        const getThemes = () => {
            let themes:any = []
            themeAttrs.value.forEach((val, idx) => {
                if (val.selected == true) {
                    themes.push({
                        name: val.name,
                        id: val.id
                    })
                }
            })
            worksFormData.themes = themes.length ? JSON.stringify(themes) : ''
            if (worksFormData.themes) {
                worksFormRule.themes.error = ''
            } else {
                worksFormRule.themes.error = '请选择建设方向'
            }
        }

        // 是不是在输入中文
        const isInputZh = ref<boolean>(false)
        // 设置input的value值
        const setInputName = (e) => {
            const target = e.target
            const name = target.getAttribute('data-name')
            const data = curIndex.value === 0 ? applyFormData : worksFormData
            const rule = curIndex.value === 0 ? applyFormRule : worksFormRule
            data[name] = e.target.value
            // 错误提示
            if (rule[name].rule && !rule[name].rule.test(data[name])) {
                rule[name].error = rule[name].msg.rule
            } else {
                rule[name].error = ''
            }
        }
        const changeInputValue = (e) => {
            if (isInputZh.value) return
            setInputName(e)
        }
        // 中文输入完成
        const compositionend = (e) => {
            isInputZh.value = false
            setInputName(e)
        }
        // 输入框失去焦点
        const blur = (e) => {
            const target = e.target
            COVERAPP.Attribute.isAndroid() && target.scrollIntoView(false)
            const name = target.getAttribute('data-name')
            const rule = curIndex.value === 0 ? applyFormRule : worksFormRule
            const data = curIndex.value === 0 ? applyFormData : worksFormData
            // 错误提示
            if (rule[name].rule && !rule[name].rule.test(data[name])) {
                rule[name].error = rule[name].msg.rule
            } else if (!data[name] && rule[name].isReuired) {
                rule[name].error = rule[name].msg.isReuired
            } else {
                rule[name].error = ''
                // 判断队伍名是否已经存在
                if (name === 'teamName') {
                    _this.proxy.$request('/temporary/xcds/team', {
                        aid: $store.state.aid,
                        phone: sessionStorage.getItem('xcds_phone'),
                        name: applyFormData.teamName
                    }).then(() => {
                        rule[name].error = ''
                    }).catch((res) => {
                        // token过期去到报名页面
                        if (res && res.errno == 1001) {
                            $router.replace('/login')
                            return
                        }
                        if (res && res.errno == 2002) {
                            rule[name].error = '队伍名称已存在！'
                        }  
                    })
                }
            }
        }

        // 勾选阅读条款
        const agree = (name: string) => {
            const rule = curIndex.value === 0 ? applyFormRule : worksFormRule
            const data = curIndex.value === 0 ? applyFormData : worksFormData
            data[name] = !data[name] ? '1' : ''
            // 错误提示
            if (data[name]) {
                rule[name].error = ''
            } else {
                rule[name].error = rule[name].msg.isReuired
            }
        }

        // 生成uuid
        const getUuid = () => {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            })
        }

        // 是否报名成功
        const isApplySuccess = ref<boolean>(false)
        // 表单提交公共方法
        const commonSubmit = (info, type?: string) => {
            // 需要把电话号码传入
            if (!info.phone) {
                info.phone = sessionStorage.getItem('xcds_phone')
            }
            _this.proxy.$request('/temporary/xcds', {
                aid: $store.state.aid,
                phone: sessionStorage.getItem('xcds_phone'),
                info
            }, 'put').then((resData) => {
                getWorkList()
                if (type === 'remove') {
                    closeRemovePop()
                    toastData.value = {
                        text: '删除成功'
                    }
                    return
                }
                isApplySuccess.value = true
                applyPopShow.value = true
                if (curIndex.value === 0) {
                    applyedData = JSON.parse(JSON.stringify(info))
                }
            }).catch((res) => {
                if (res && res.errno == 1001) {
                    $router.replace('/login')
                    return
                }
                if (res && res.errno == 2002) {
                    applyFormRule.teamName.error = '队伍名称已存在！'
                    return
                }
                if (type === 'remove') {
                    closeRemovePop()
                    toastData.value = {
                        type: 'error',
                        text: '删除失败'
                    }
                    return
                }
                popStautsData.value = {
                    type: 'shibai',
                    text: '提交失败，请重试！'
                }
            })
        }
        // 提交表单
        const submit = async () => {
            const rule = curIndex.value === 0 ? applyFormRule : worksFormRule
            const data = curIndex.value === 0 ? applyFormData : worksFormData
            let isSubmit = true
            // 如果有资源在上传，则不能提交表单
            const progress = document.querySelectorAll('.progress')
            for (let i = 0; i < progress.length; i++) {
                if (!(progress[i] as any).style.display) {
                    isSubmit = false
                }
            }
            if (!isSubmit) {
                popStautsData.value = {
                    type: 'shibai',
                    text: '资源上传中，请在资源上传完成后提交'
                }
            }
            // 验证表单
            for(let key in data) {
                if (rule[key].error && (!rule[key].maxLen || !data[key])) {
                    isSubmit = false
                } else if (!data[key] && rule[key].isReuired) {
                    rule[key].error = rule[key].msg.isReuired
                    isSubmit = false
                }   
            }
            if (isSubmit) {
                _this.proxy.$request('/temporary/xcds', {
                    aid: $store.state.aid,
                    phone: sessionStorage.getItem('xcds_phone')
                }).then((data) => {
                    if (data) {
                        worksList.value = data.worksList ? JSON.parse(data.worksList) : []
                    }
                    if (getWorksNum() > 3) {
                        worksOverPopShow.value = true
                        return
                    }
                    let newList = JSON.parse(JSON.stringify(worksList.value))
                    let isAdd = true
                    if (currentWorkItem.value) { // 修改
                        for (let i = 0; i < newList.length; i++) {
                            if (newList[i]._id === currentWorkItem.value._id) {
                                isAdd = false
                                newList[i] = JSON.parse(JSON.stringify(worksFormData))
                                newList[i]._id = currentWorkItem.value._id
                                break
                            }
                        }
                    }
                    if (isAdd) { // 新增
                        newList.push(Object.assign(JSON.parse(JSON.stringify(worksFormData)), {_id: currentWorkItem.value ? currentWorkItem.value._id : getUuid()}))
                    }
                    let info = JSON.parse(JSON.stringify(curIndex.value === 1 ? Object.assign(applyedData, {
                        worksList: JSON.stringify(newList)
                    }) : Object.assign(applyedData, applyFormData)))
                    commonSubmit(info)
                }).catch((res) => {
                    // token过期去到报名页面
                    if (res && res.errno == 1001) {
                        $router.replace('/login')
                        return
                    }
                    popStautsData.value = {
                        type: 'shibai',
                        text: '提交失败，请重试！'
                    }
                })      
            }
        }

        // 选择的当前建设方向下作品数
        const getWorksNum = () => {
            const currentThemes = worksFormData.themes ? JSON.parse(worksFormData.themes) : []
            const currentThemesIds = currentThemes.map((val) => {
                return val.id
            })
            let num = worksFormData.works.split(',').length
            worksList.value.forEach((val) => {
                const themes = val.themes ? JSON.parse(val.themes) : []
                const valThemesIds = themes.map((val) => {
                    return val.id
                })
                if (valThemesIds.join() === currentThemesIds.join() && (!currentWorkItem.value || currentWorkItem.value._id !== val._id)) {
                    console.log(val.works.split(',').length)
                    num += val.works.split(',').length
                }
            })
            return num
        }

        const currentWorkItem = ref<any>(null)
        // 删除作品
        const removeConfirmShow = ref<boolean>(false)
        // 选中历史作品
        const chooseWork = (item, type?: string) => {
            currentWorkItem.value = item
            if (type === 'remove') {
                removeConfirmShow.value = true
            }
        }

        // 去修改选中历史作品
        const editWorksFormData = () => {
            if (COVERAPP.Attribute.isMb()) {
                wapUploadPopShow.value = true
                return
            }
            const item = currentWorkItem.value
            if (!item) return
            // 本来就在提交作品页面，需要刷新界面，重置上面组件里面的数据
            isRefreshPage.value = true
            clearWorksFormData()
            nextTick(() => {
                isRefreshPage.value = false
                for(let key in worksFormData) {
                    item[key] && (worksFormData[key] = item[key])
                }
                if (worksFormData.themes) {
                    const themes = JSON.parse(worksFormData.themes).map((val) => {
                        return val.id
                    })
                    themeAttrs.value.forEach((val) => {
                        if (themes.indexOf(val.id) > -1) {
                            val.selected = true
                        }
                        return val
                    })
                }
                applyPopShow.value = false
                worksListShow.value = false
                curIndex.value = 1
            })
        }

        // 删除
        const removeWork = () => {
            const item = currentWorkItem.value
            _this.proxy.$request('/temporary/xcds', {
                aid: $store.state.aid,
                phone: sessionStorage.getItem('xcds_phone')
            }).then((data) => {
                let list: any[] = []
                if (data && data.worksList) {
                    applyedData = JSON.parse(JSON.stringify(data))
                    list = JSON.parse(data.worksList)
                    let index: any = ''
                    list.forEach((val, idx) => {
                        if (val._id === item._id) {
                            index = idx
                        }
                    })
                    if (index !== '') {
                        list.splice(index, 1)
                    }
                }
                let info = JSON.parse(JSON.stringify(Object.assign(applyedData, {
                    worksList: list.length ? JSON.stringify(list) : ''
                })))
                commonSubmit(info, 'remove')
            }).catch((res) => {
                // token过期去到报名页面
                if (res && res.errno == 1001) {
                    $router.replace('/login')
                    return
                }
                closeRemovePop()
                popStautsData.value = {
                    type: 'shibai',
                    text: '删除失败，请重试！'
                }
            })
        }

        // 关闭确认删除弹框
        const closeRemovePop = () => {
            removeConfirmShow.value = false
            currentWorkItem.value = null
        }

        const closeWorksListPop = () => {
            worksListShow.value = false
            currentWorkItem.value = null
        }

        // 获取作品列表
        const getWorkList = () => {
             _this.proxy.$request('/temporary/xcds', {
                aid: $store.state.aid,
                phone: sessionStorage.getItem('xcds_phone')
            }).then((data) => {
                if (data) {
                    worksList.value = data.worksList ? JSON.parse(data.worksList) : []
                    // 如果有选中数据，重新获取一下最新的选中数据
                    if (currentWorkItem.value && currentWorkItem.value._id) {
                        worksList.value.forEach((val) => {
                            if (val._id === currentWorkItem.value._id) {
                                currentWorkItem.value = val
                            }
                        })
                    }
                }
            }).catch((res) => {
                // token过期去到报名页面
                if (res && res.errno == 1001) {
                    $router.replace('/login')
                }
            })
        }

        // 去提交作品
        const isRefreshPage = ref<boolean>(false)
        const goToWorks = () => {
            if (!COVERAPP.Attribute.isMb()) {
                isApplyed.value = true
                applyPopShow.value = false
                currentWorkItem.value = null
                // 本来就在提交作品页面，需要刷新界面，重置上面组件里面的数据
                if (curIndex.value == 1) {
                    isRefreshPage.value = true
                    nextTick(() => {
                        isRefreshPage.value = false
                        curIndex.value = 1
                        clearWorksFormData()
                    })
                } else {
                    curIndex.value = 1
                    clearWorksFormData()
                } 
            } else {
                wapUploadPopShow.value = true
            }      
        }

        // 关闭条款弹框
        const colsePop = () => {
            popType.value = 0
        }

        // 上传组件报错
        const uploaderror = (data) => {
            if (data.name === 'works' && data.errorType === 'limit') {
                worksOverPopShow.value = true
                return
            }
            const rule = data.formIndex === 1 ? worksFormRule : applyFormRule
            rule[data.name].error = data.errorText ? data.errorText === ' ' ? '' : data.errorText : rule[data.name].msg[data.errorType || 'size']
        }
        // 上传组件上传文件成功
        const uploaded = (data) => {
            const formData = data.formIndex === 1 ? worksFormData : applyFormData
            const rule = data.formIndex === 1 ? worksFormRule : applyFormRule
            formData[data.name] = data.url
            rule[data.name].error = ''
            if (data.fileName) {
                formData[data.fileName] = data.fileNames
            }
        }

        // 下载
        const download = (e) => {
            e.preventDefault()
            axios.get(e.target.href, {responseType:'blob'}).then(res => {
                const blob = new Blob([res.data])
                let a = document.createElement('a')
                a.href=URL.createObjectURL(blob)
                a.download = e.target.download
                a.click()
            })
        }

        // 点击提交作品tab
        const isHandleWorksTab = ref<boolean>(false)
        const handleWorksTab = () => {
            applyPopShow.value = true
            isHandleWorksTab.value = true
            getWorkList()
        }
        
        // 切换tab
        const changeTab = (index: number) => {
            if (index === 0) {
                curIndex.value = 0
                currentWorkItem.value = null
                clearWorksFormData()
            } else {
                handleWorksTab()
            }
        }

        // 清空作品填空数据
        const clearWorksFormData = () => {
            for(let key in worksFormData) {
                worksFormData[key] = ''
                themeAttrs.value.forEach((val, idx) => {
                    val.selected = false
                    return val
                })
            }
        }

        // 复制
        const { toClipboard } = useClipboard()
        const copy = async () => {
            try {
                await toClipboard('http://mtest.thecover.cn/2022sztfapply/#/')
                toastData.value = {
                    text: '复制成功'
                }
            } catch (e) {
                toastData.value = {
                    type: 'error',
                    text: '复制出错'
                }
            }
        }

        // toastData三秒后消失
        watch(() => toastData.value, (val) => {
            if (val) {
                setTimeout(() => {
                    toastData.value = null
                }, 3000)
            }
        })

        // 状态弹框数据
        const popStautsData = ref<any>(null)

        onMounted(() => {
            _this.proxy.$common.track('load', '进入首页')
            _this.proxy.$common.onshare($store.state.shareData)
            canApply.value = new Date().getTime() >= new Date('2022/06/01 00:00:00').getTime()
        })

        onBeforeUnmount(() => {
            
        })
        

        return {
            curIndex,
            wapUploadPopShow,
            popType,
            applyPopShow,
            toastData,
            isApplyed,
            worksOverPopShow,
            worksList,
            worksListShow,
            canApply,
            teamAttrs,
            applyFormData,
            applyFormRule,
            worksFormData,
            worksFormRule,
            themeAttrs,
            isGetInfoed,
            isInputZh,
            changeInputValue,
            compositionend,
            blur,
            selectTeam,
            selectTheme,
            removeSelected,
            colsePop,
            uploaderror,
            uploaded,
            isApplySuccess,
            submit,
            currentWorkItem,
            chooseWork,
            editWorksFormData,
            removeConfirmShow,
            removeWork,
            closeRemovePop,
            closeWorksListPop,
            isRefreshPage,
            goToWorks,
            agree,
            download,
            isHandleWorksTab,
            changeTab,
            copy,
            popStautsData
        }
    }
})
